import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import jsPDF from 'jspdf';
import { 
    FaCar, FaPlus, FaArrowLeft, FaIdCard, FaFileDownload, 
    FaTachometerAlt, FaExclamationTriangle, FaCalendarPlus, 
    FaWhatsapp, FaPrint, FaTrash, FaRoad, FaPalette, FaMapMarkerAlt, 
    FaEdit, FaEye, FaShieldAlt, FaFileContract, FaCalendarAlt,
    FaCheckCircle, FaClock, FaTools, FaHistory, FaInfoCircle,
    FaFileAlt, FaGasPump, FaMoneyBillWave, FaFileUpload, FaImage
} from 'react-icons/fa';

export default function Vehiculos({ goBack }) {
    const [vehiculos, setVehiculos] = useState([]);
    const [selectedCar, setSelectedCar] = useState(null);
    const [detalleData, setDetalleData] = useState(null);
    const [activeTab, setActiveTab] = useState('rentas'); 
    const [filterStatus, setFilterStatus] = useState('todos'); // 'todos', 'libre', 'ocupado'

const getEstadoRenta = (renta) => {
    const hoy = new Date();
    hoy.setHours(0, 0, 0, 0);
    const fechaFin = new Date(renta.fecha_fin);
    fechaFin.setHours(0, 0, 0, 0);
    
    // COMPLETADO: tiene km_retorno (ya se devolvió)
    if (renta.km_retorno && parseFloat(renta.km_retorno) > 0) {
        return { estado: 'COMPLETADO', color: '#0d6efd', bg: '#cfe2ff' };
    }
    
    // VENCIDO: fecha_fin < hoy y no devuelto
    if (fechaFin < hoy) {
        return { estado: 'VENCIDO', color: '#fd7e14', bg: '#ffe5d0' };
    }
    
    // EN CURSO: fecha_fin >= hoy
    return { estado: 'EN CURSO', color: '#198754', bg: '#d1e7dd' };
};

// Detectar si hubo ampliaciones
const tieneAmpliaciones = (renta) => {
    return renta.observaciones && renta.observaciones.includes('[Ampliación');
};
    
    // Estados del Modal (Añadir/Editar)
    const [showModal, setShowModal] = useState(false); 
    const [modalMode, setModalMode] = useState('add'); // 'add' o 'edit'
    const [editId, setEditId] = useState(null);
    const [imagePreview, setImagePreview] = useState(null); // NUEVO: Preview de imagen

    const [form, setForm] = useState({
        marca: '', modelo: '', anio: '', placa: '', color: '', 
        precio_dia: '', kilometraje_actual: 0,
        vencimiento_soat: '', vencimiento_seguro: '', vencimiento_ruat: '', 
        vencimiento_impuestos: '', link_gps: '', imagen: null
    });

    useEffect(() => { fetchVehiculos(); }, []);

    const fetchVehiculos = async () => {
        try {
            const res = await axios.get('https://api.alquilacarbolivia.com/api/vehiculos');
            const vehiculosConImagenCompleta = res.data.map(v => ({...v, imagen_url: v.imagen_url?.startsWith("http") ? v.imagen_url : v.imagen_url ? `https://api.alquilacarbolivia.com${v.imagen_url}` : null}));
            setVehiculos(vehiculosConImagenCompleta);
        } catch (error) { console.error(error); }
    };

    const handleSelectCar = async (car) => {
        setSelectedCar(car);
        try {
            const res = await axios.get(`https://api.alquilacarbolivia.com/api/vehiculos/${car.id}`);
            setDetalleData(res.data);
            setActiveTab('rentas'); 
        } catch (error) { console.error(error); }
    };

    const closeDetail = () => {
        setSelectedCar(null);
        setDetalleData(null);
    };

    const openAddModal = () => {
        setModalMode('add');
        setImagePreview(null); // NUEVO: Limpiar preview
        setForm({
            marca: '', modelo: '', anio: '', placa: '', color: '', 
            precio_dia: '', kilometraje_actual: 0,
            vencimiento_soat: '', vencimiento_seguro: '', vencimiento_ruat: '', 
            vencimiento_impuestos: '', link_gps: '', imagen: null
        });
        setShowModal(true);
    };

    const openEditModal = (car) => {
        setModalMode('edit');
        setEditId(car.id);
        setImagePreview(car.imagen_url); // NUEVO: Cargar imagen existente en preview
        setForm({
            ...car,
            imagen: null, // Inicialmente null, se actualiza solo si el usuario sube nueva imagen
            vencimiento_soat: car.vencimiento_soat ? car.vencimiento_soat.split('T')[0] : '',
            vencimiento_seguro: car.vencimiento_seguro ? car.vencimiento_seguro.split('T')[0] : '',
            vencimiento_ruat: car.vencimiento_ruat ? car.vencimiento_ruat.split('T')[0] : '',
            vencimiento_impuestos: car.vencimiento_impuestos ? car.vencimiento_impuestos.split('T')[0] : '',
        });
        closeDetail();
        setShowModal(true);
    };

    // NUEVO: Manejar cambio de imagen
    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setForm({ ...form, imagen: file });
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const handleSaveVehiculo = async (e) => {
    e.preventDefault();
    const data = new FormData();
    
    // Adjuntar todos los campos del formulario al FormData
    Object.keys(form).forEach(key => {
        if (form[key] !== null && form[key] !== undefined) {
            data.append(key, form[key]);
        }
    });

    try {
        if (modalMode === 'add') {
            await axios.post('https://api.alquilacarbolivia.com/api/vehiculos', data);
        } else {
            // La llamada PUT también debe enviar FormData
            await axios.put(`https://api.alquilacarbolivia.com/api/vehiculos/${editId}`, data);
        }
        
        Swal.fire('¡Éxito!', 'Vehículo guardado correctamente', 'success');
        setShowModal(false);
        fetchVehiculos();
    } catch (error) { 
        console.error("Error al guardar:", error.response?.data || error.message);
        Swal.fire('Error', 'No se pudo guardar la información', 'error'); 
    }
};

    const handleDelete = async (car) => {
        const res = await Swal.fire({
            title: `¿Eliminar ${car.marca} ${car.modelo}?`,
            text: 'Esta acción no se puede deshacer',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar'
        });
        if(res.isConfirmed) {
            try {
                await axios.delete(`https://api.alquilacarbolivia.com/api/vehiculos/${car.id}`);
                closeDetail();
                fetchVehiculos();
                Swal.fire('Eliminado', 'Vehículo eliminado de la flota', 'success');
            } catch (error) { 
                Swal.fire('Error', 'No se puede eliminar (posibles rentas activas)', 'error'); 
            }
        }
    };

    const checkVencimiento = (fecha) => {
        if (!fecha) return false;
        const hoy = new Date();
        const v = new Date(fecha);
        return ((v - hoy) / (1000 * 60 * 60 * 24)) <= 15;
    };

    // FUNCIÓN MEJORADA PARA GENERAR CONTRATO DE AMPLIACIÓN
    const generarContratoAmpliacionPDF = (renta, car, fechaOriginal, nuevaFecha, diasExtension, montoAdicional, nuevoTotal) => {
        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.width;
        const pageHeight = doc.internal.pageSize.height;
        
        // === ENCABEZADO CON DISEÑO MODERNO ===
        doc.setFillColor(34, 139, 34);
        doc.rect(0, 0, pageWidth, 45, 'F');
        
        // Logo/Icono simulado
        doc.setFillColor(255, 255, 255);
        doc.circle(30, 22, 12, 'F');
        doc.setFillColor(34, 139, 34);
        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        doc.text('AC', 30, 25, { align: 'center' });
        
        // Título empresa
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(24);
        doc.text('ALQUILACAR S.R.L.', 50, 20);
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.text('Alquiler de Vehículos Premium', 50, 28);
        doc.text('www.alquilacar.com | info@alquilacar.com', 50, 34);
        
        // Número de ampliación en badge
        doc.setFillColor(255, 165, 0); // Naranja para diferenciarlo
        doc.roundedRect(pageWidth - 60, 10, 50, 12, 2, 2, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        const ampliacionNum = Date.now().toString().slice(-8);
        doc.text(`AMPLIACIÓN`, pageWidth - 35, 16, { align: 'center' });
        doc.setFontSize(7);
        doc.text(`N° ${ampliacionNum}`, pageWidth - 35, 20, { align: 'center' });
        
        // Fecha
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        doc.text(`Fecha: ${new Date().toLocaleDateString('es-ES')}`, pageWidth - 35, 30, { align: 'center' });
        
        // === TÍTULO DOCUMENTO ===
        doc.setTextColor(255, 165, 0);
        doc.setFontSize(20);
        doc.setFont("helvetica", "bold");
        doc.text('AMPLIACIÓN DE CONTRATO', pageWidth / 2, 60, { align: 'center' });
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.text('DE ARRENDAMIENTO DE VEHÍCULO', pageWidth / 2, 67, { align: 'center' });
        
        // === REFERENCIA AL CONTRATO ORIGINAL ===
        let yPos = 80;
        doc.setFillColor(255, 248, 220); // Color crema claro
        doc.roundedRect(15, yPos, pageWidth - 30, 15, 3, 3, 'F');
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        doc.text('CONTRATO ORIGINAL:', 20, yPos + 6);
        doc.setFont("helvetica", "normal");
        doc.text(`Ticket #${renta.id.toString().padStart(6, '0')}`, 70, yPos + 6);
        doc.text(`Fecha Inicio: ${new Date(renta.fecha_inicio).toLocaleDateString('es-ES')}`, 20, yPos + 11);
        
        // === SECCIÓN 1: PARTES ===
        yPos += 25;
        doc.setDrawColor(255, 165, 0);
        doc.setLineWidth(0.5);
        doc.roundedRect(15, yPos, pageWidth - 30, 35, 3, 3);
        
        doc.setFillColor(255, 165, 0);
        doc.rect(15, yPos, pageWidth - 30, 8, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(11);
        doc.setFont("helvetica", "bold");
        doc.text('I. PARTES CONTRATANTES', 20, yPos + 5.5);
        
        yPos += 15;
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.text('ARRENDADOR:', 20, yPos);
        doc.setFont("helvetica", "normal");
        doc.text('ALQUILACAR S.R.L.', 50, yPos);
        
        yPos += 7;
        doc.setFont("helvetica", "bold");
        doc.text('ARRENDATARIO:', 20, yPos);
        doc.setFont("helvetica", "normal");
        doc.text(renta.cliente.toUpperCase(), 50, yPos);
        
        // === SECCIÓN 2: VEHÍCULO ===
        yPos += 15;
        doc.setDrawColor(255, 165, 0);
        doc.roundedRect(15, yPos, pageWidth - 30, 30, 3, 3);
        
        doc.setFillColor(255, 165, 0);
        doc.rect(15, yPos, pageWidth - 30, 8, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(11);
        doc.setFont("helvetica", "bold");
        doc.text('II. VEHÍCULO ARRENDADO', 20, yPos + 5.5);
        
        yPos += 15;
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        
        doc.setFont("helvetica", "bold");
        doc.text('MARCA:', 20, yPos);
        doc.setFont("helvetica", "normal");
        doc.text(car.marca, 40, yPos);
        
        doc.setFont("helvetica", "bold");
        doc.text('MODELO:', 90, yPos);
        doc.setFont("helvetica", "normal");
        doc.text(car.modelo, 110, yPos);
        
        doc.setFont("helvetica", "bold");
        doc.text('PLACA:', 150, yPos);
        doc.setFont("helvetica", "normal");
        doc.text(car.placa, 170, yPos);
        
        // === SECCIÓN 3: MODIFICACIÓN DE FECHAS (DESTACADO) ===
        yPos += 20;
        doc.setDrawColor(255, 165, 0);
        doc.setLineWidth(1);
        doc.roundedRect(15, yPos, pageWidth - 30, 60, 3, 3);
        
        doc.setFillColor(255, 165, 0);
        doc.rect(15, yPos, pageWidth - 30, 8, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(11);
        doc.setFont("helvetica", "bold");
        doc.text('III. MODIFICACIÓN DE PLAZO Y CONDICIONES', 20, yPos + 5.5);
        
        yPos += 18;
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        
        // Fecha original con tachado visual
        doc.setFillColor(255, 240, 240);
        doc.roundedRect(18, yPos - 4, (pageWidth - 36) / 2 - 2, 18, 2, 2, 'F');
        
        doc.setFont("helvetica", "bold");
        doc.text('FECHA DEVOLUCIÓN ORIGINAL:', 22, yPos + 2);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(150, 0, 0);
        const fechaOriginalStr = new Date(fechaOriginal).toLocaleDateString('es-ES');
        doc.text(fechaOriginalStr, 22, yPos + 8);
        
        // Línea tachada sobre la fecha original
        doc.setDrawColor(255, 0, 0);
        doc.setLineWidth(0.8);
        const textWidth = doc.getTextWidth(fechaOriginalStr);
        doc.line(22, yPos + 7, 22 + textWidth, yPos + 7);
        
        // Nueva fecha resaltada
        doc.setFillColor(240, 255, 240);
        doc.roundedRect(18 + (pageWidth - 36) / 2 + 2, yPos - 4, (pageWidth - 36) / 2 - 2, 18, 2, 2, 'F');
        
        doc.setTextColor(0, 100, 0);
        doc.setFont("helvetica", "bold");
        doc.text('NUEVA FECHA DE DEVOLUCIÓN:', pageWidth / 2 + 8, yPos + 2);
        doc.setFontSize(12);
        doc.text(new Date(nuevaFecha).toLocaleDateString('es-ES'), pageWidth / 2 + 8, yPos + 8);
        
        yPos += 22;
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0);
        
        // Días adicionales
        doc.setFont("helvetica", "bold");
        doc.text('DÍAS ADICIONALES:', 22, yPos);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(34, 139, 34);
        doc.setFontSize(12);
        doc.text(`+ ${diasExtension} día(s)`, 70, yPos);
        
        // === SECCIÓN 4: CONDICIONES ECONÓMICAS ===
        yPos += 15;
        doc.setDrawColor(255, 165, 0);
        doc.setLineWidth(0.5);
        doc.roundedRect(15, yPos, pageWidth - 30, 45, 3, 3);
        
        doc.setFillColor(255, 165, 0);
        doc.rect(15, yPos, pageWidth - 30, 8, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(11);
        doc.setFont("helvetica", "bold");
        doc.text('IV. CONDICIONES ECONÓMICAS', 20, yPos + 5.5);
        
        yPos += 15;
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        
        // Tabla de costos
        doc.setFont("helvetica", "bold");
        doc.text('MONTO ORIGINAL:', 22, yPos);
        doc.setFont("helvetica", "normal");
        doc.text(`Bs. ${parseFloat(renta.total).toFixed(2)}`, 70, yPos);
        
        yPos += 7;
        doc.setFont("helvetica", "bold");
        doc.text('DÍAS ADICIONALES:', 22, yPos);
        doc.setFont("helvetica", "normal");
        doc.text(`${diasExtension} x Bs. ${(montoAdicional / diasExtension).toFixed(2)}`, 70, yPos);
        
        yPos += 7;
        doc.setFont("helvetica", "bold");
        doc.text('MONTO ADICIONAL:', 22, yPos);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(255, 140, 0);
        doc.text(`+ Bs. ${parseFloat(montoAdicional).toFixed(2)}`, 70, yPos);
        
        // Total general destacado
        yPos += 12;
        doc.setFillColor(255, 215, 0);
        doc.roundedRect(18, yPos - 5, pageWidth - 36, 12, 2, 2, 'F');
        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 0, 0);
        doc.text(`NUEVO TOTAL A PAGAR: Bs. ${parseFloat(nuevoTotal).toFixed(2)}`, pageWidth / 2, yPos + 2, { align: 'center' });
        
        // === CLÁUSULAS ===
        yPos += 18;
        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(255, 140, 0);
        doc.text('CLÁUSULAS DE LA AMPLIACIÓN:', 15, yPos);
        
        yPos += 5;
        doc.setFontSize(8);
        doc.setTextColor(0, 0, 0);
        doc.setFont("helvetica", "normal");
        
        const clausulas = [
            '1. El presente documento constituye una AMPLIACIÓN del contrato original y modifica únicamente la fecha de devolución y el monto total.',
            '2. Todas las demás condiciones del contrato original permanecen vigentes e inalteradas.',
            '3. El arrendatario se compromete a devolver el vehículo en la nueva fecha estipulada en las mismas condiciones acordadas.',
            '4. El pago del monto adicional deberá realizarse antes o al momento de la devolución del vehículo.'
        ];
        
        clausulas.forEach(clausula => {
            const lines = doc.splitTextToSize(clausula, pageWidth - 30);
            doc.text(lines, 15, yPos);
            yPos += lines.length * 4;
        });
        
        // Pie de página
        doc.setFontSize(7);
        doc.setTextColor(128, 128, 128);
        doc.text('Este documento es un anexo legal al contrato original. Conserve ambos documentos juntos.', pageWidth / 2, pageHeight - 10, { align: 'center' });
        
        doc.save(`Ampliacion_Contrato_${car.placa}_${ampliacionNum}.pdf`);
    };

const descargarContratoPDFCompleto = (renta, car) => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height;
    
    const estadoInfo = getEstadoRenta(renta);
    const hayAmpliaciones = tieneAmpliaciones(renta);
    const estaCompletado = estadoInfo.estado === 'COMPLETADO';

    // ==================== PÁGINA 1: CONTRATO ORIGINAL ====================
    // Encabezado
    doc.setFillColor(34, 139, 34);
    doc.rect(0, 0, pageWidth, 45, 'F');
    
    doc.setFillColor(255, 255, 255);
    doc.circle(30, 22, 12, 'F');
    doc.setFillColor(34, 139, 34);
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text('AC', 30, 25, { align: 'center' });
    
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(24);
    doc.text('ALQUILACAR S.R.L.', 50, 20);
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text('Alquiler de Vehículos Premium', 50, 28);
    doc.text('www.alquilacar.com | info@alquilacar.com', 50, 34);
    
    doc.setFillColor(255, 215, 0);
    doc.roundedRect(pageWidth - 55, 10, 45, 12, 2, 2, 'F');
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.text(`TICKET #${renta.id}`, pageWidth - 32.5, 18, { align: 'center' });
    
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text(`Emisión: ${new Date(renta.created_at || renta.fecha_inicio).toLocaleDateString('es-ES')}`, pageWidth - 32.5, 30, { align: 'center' });
    
    doc.setTextColor(34, 139, 34);
    doc.setFontSize(18);
    doc.setFont("helvetica", "bold");
    doc.text('CONTRATO DE ARRENDAMIENTO', pageWidth / 2, 60, { align: 'center' });
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text('DE VEHÍCULO AUTOMOTOR', pageWidth / 2, 67, { align: 'center' });
    
    let yPos = 80;
    
    // Sección 1: Partes
    doc.setDrawColor(34, 139, 34);
    doc.setLineWidth(0.5);
    doc.roundedRect(15, yPos, pageWidth - 30, 40, 3, 3);
    
    doc.setFillColor(34, 139, 34);
    doc.rect(15, yPos, pageWidth - 30, 8, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text('I. PARTES CONTRATANTES', 20, yPos + 5.5);
    
    yPos += 15;
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text('ARRENDADOR:', 20, yPos);
    doc.setFont("helvetica", "normal");
    doc.text('ALQUILACAR S.R.L.', 50, yPos);
    
    yPos += 7;
    doc.setFont("helvetica", "bold");
    doc.text('ARRENDATARIO:', 20, yPos);
    doc.setFont("helvetica", "normal");
    doc.text(renta.cliente.toUpperCase(), 50, yPos);
    
    yPos += 7;
    doc.setFont("helvetica", "bold");
    doc.text('TELÉFONO:', 110, yPos);
    doc.setFont("helvetica", "normal");
    doc.text(renta.cliente_telefono || 'N/A', 135, yPos);
    
    // Sección 2: Vehículo
    yPos += 15;
    doc.setDrawColor(34, 139, 34);
    doc.roundedRect(15, yPos, pageWidth - 30, 45, 3, 3);
    
    doc.setFillColor(34, 139, 34);
    doc.rect(15, yPos, pageWidth - 30, 8, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text('II. VEHÍCULO ARRENDADO', 20, yPos + 5.5);
    
    yPos += 15;
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);
    
    doc.setFont("helvetica", "bold");
    doc.text('MARCA:', 20, yPos);
    doc.setFont("helvetica", "normal");
    doc.text(car.marca, 40, yPos);
    
    doc.setFont("helvetica", "bold");
    doc.text('MODELO:', 90, yPos);
    doc.setFont("helvetica", "normal");
    doc.text(car.modelo, 110, yPos);
    
    doc.setFont("helvetica", "bold");
    doc.text('AÑO:', 150, yPos);
    doc.setFont("helvetica", "normal");
    doc.text(car.anio.toString(), 165, yPos);
    
    yPos += 8;
    doc.setFont("helvetica", "bold");
    doc.text('PLACA:', 20, yPos);
    doc.setFont("helvetica", "normal");
    doc.text(car.placa, 40, yPos);
    
    doc.setFont("helvetica", "bold");
    doc.text('COLOR:', 90, yPos);
    doc.setFont("helvetica", "normal");
    doc.text(car.color, 110, yPos);
    
    yPos += 10;
    doc.setFillColor(240, 248, 255);
    doc.roundedRect(18, yPos - 3, pageWidth - 36, 12, 2, 2, 'F');
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(34, 139, 34);
    doc.text('CONDICIONES DE ENTREGA:', 22, yPos + 2);
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "normal");
    doc.text(`KM: ${renta.km_salida || 'N/A'} | Combustible: ${renta.nivel_gasolina_salida || 'Full'}`, 22, yPos + 7);
    
    // Sección 3: Condiciones ORIGINALES
    yPos += 18;
    doc.setDrawColor(34, 139, 34);
    doc.roundedRect(15, yPos, pageWidth - 30, 55, 3, 3);
    
    doc.setFillColor(34, 139, 34);
    doc.rect(15, yPos, pageWidth - 30, 8, 'F');
    doc.setTextColor(255, 255, 255);
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text('III. CONDICIONES ECONÓMICAS Y PLAZO', 20, yPos + 5.5);
    
    yPos += 15;
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);
    
    const fechaIni = new Date(renta.fecha_inicio);
    const diffDays = Math.ceil((new Date(renta.fecha_fin) - fechaIni) / (1000 * 60 * 60 * 24));
    
    doc.setFont("helvetica", "bold");
    doc.text('FECHA INICIO:', 20, yPos);
    doc.setFont("helvetica", "normal");
    doc.text(fechaIni.toLocaleDateString('es-ES'), 55, yPos);
    
    doc.setFont("helvetica", "bold");
    doc.text('FECHA FIN:', 110, yPos);
    doc.setFont("helvetica", "normal");
    doc.text(new Date(renta.fecha_fin).toLocaleDateString('es-ES'), 138, yPos);
    
    yPos += 8;
    doc.setFont("helvetica", "bold");
    doc.text('DÍAS TOTALES:', 20, yPos);
    doc.setFont("helvetica", "normal");
    doc.text(diffDays.toString(), 55, yPos);
    
    doc.setFont("helvetica", "bold");
    doc.text('TARIFA DIARIA:', 110, yPos);
    doc.setFont("helvetica", "normal");
    doc.text(`Bs. ${parseFloat(renta.precio_dia_acordado || car.precio_dia).toFixed(2)}`, 138, yPos);
    
    yPos += 8;
    doc.setFont("helvetica", "bold");
    doc.text('GARANTÍA:', 20, yPos);
    doc.setFont("helvetica", "normal");
    doc.text(`Bs. ${parseFloat(renta.garantia).toFixed(2)}`, 55, yPos);
    
    // Total destacado
    yPos += 12;
    doc.setFillColor(255, 215, 0);
    doc.roundedRect(18, yPos - 5, pageWidth - 36, 30, 2, 2, 'F');
    
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(0, 0, 0);
    doc.text(`TOTAL CONTRATO: Bs. ${parseFloat(renta.total).toFixed(2)}`, pageWidth / 2, yPos + 2, { align: 'center' });
    
    yPos += 6;
    doc.setFontSize(10);
    doc.text(`+ Garantía: Bs. ${parseFloat(renta.garantia).toFixed(2)}`, pageWidth / 2, yPos + 2, { align: 'center' });
    
    yPos += 4;
    doc.setLineWidth(0.5);
    doc.setDrawColor(0, 0, 0);
    doc.line(pageWidth / 2 - 40, yPos + 2, pageWidth / 2 + 40, yPos + 2);
    
    yPos += 6;
    doc.setFontSize(12);
    const totalConGarantia = parseFloat(renta.total) + parseFloat(renta.garantia);
    doc.text(`TOTAL A PAGAR: Bs. ${totalConGarantia.toFixed(2)}`, pageWidth / 2, yPos + 2, { align: 'center' });
    
    // Cláusulas
    yPos += 18;
    doc.setFontSize(9);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(34, 139, 34);
    doc.text('CLÁUSULAS Y CONDICIONES:', 15, yPos);
    
    yPos += 5;
    doc.setFontSize(8);
    doc.setTextColor(0, 0, 0);
    doc.setFont("helvetica", "normal");
    
    const clausulas = [
        '1. El arrendatario declara haber recibido el vehículo en perfectas condiciones.',
        '2. Cualquier daño o multa será responsabilidad del arrendatario.',
        '3. La garantía será devuelta al finalizar, previa inspección.'
    ];
    
    clausulas.forEach(clausula => {
        const lines = doc.splitTextToSize(clausula, pageWidth - 30);
        doc.text(lines, 15, yPos);
        yPos += lines.length * 4;
    });
    
    doc.setFontSize(7);
    doc.setTextColor(128, 128, 128);
    doc.text('Contrato legalmente vinculante. Conserve para sus registros.', pageWidth / 2, pageHeight - 10, { align: 'center' });
    
    // ==================== SI HAY AMPLIACIONES, AGREGAR PÁGINAS ====================
// ==================== SI HAY AMPLIACIONES, AGREGAR PÁGINA ====================
    if (hayAmpliaciones) {
        doc.addPage();
        
        // Encabezado ampliación
        doc.setFillColor(255, 165, 0);
        doc.rect(0, 0, pageWidth, 45, 'F');
        
        doc.setFillColor(255, 255, 255);
        doc.circle(30, 22, 12, 'F');
        doc.setFillColor(255, 165, 0);
        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        doc.text('AC', 30, 25, { align: 'center' });
        
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(24);
        doc.text('ALQUILACAR S.R.L.', 50, 20);
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.text('Alquiler de Vehículos Premium', 50, 28);
        
        doc.setFillColor(255, 140, 0);
        doc.roundedRect(pageWidth - 60, 10, 50, 12, 2, 2, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        doc.text(`AMPLIACIÓN`, pageWidth - 35, 18, { align: 'center' });
        
        doc.setTextColor(255, 165, 0);
        doc.setFontSize(20);
        doc.setFont("helvetica", "bold");
        doc.text('AMPLIACIÓN DE CONTRATO', pageWidth / 2, 60, { align: 'center' });
        
        let yPosAmp = 75;
        
        // Referencia al contrato original
        doc.setFillColor(255, 248, 220);
        doc.roundedRect(15, yPosAmp, pageWidth - 30, 15, 3, 3, 'F');
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        doc.text('CONTRATO ORIGINAL:', 20, yPosAmp + 6);
        doc.setFont("helvetica", "normal");
        doc.text(`Ticket #${renta.id}`, 70, yPosAmp + 6);
        doc.text(`Fecha Inicio: ${new Date(renta.fecha_inicio).toLocaleDateString('es-ES')}`, 20, yPosAmp + 11);
        
        yPosAmp += 25;
        
        // Observaciones de ampliación
        doc.setDrawColor(255, 165, 0);
        doc.setLineWidth(0.5);
        doc.roundedRect(15, yPosAmp, pageWidth - 30, 50, 3, 3);
        
        doc.setFillColor(255, 165, 0);
        doc.rect(15, yPosAmp, pageWidth - 30, 8, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(11);
        doc.setFont("helvetica", "bold");
        doc.text('HISTORIAL DE MODIFICACIONES', 20, yPosAmp + 5.5);
        
        yPosAmp += 15;
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(9);
        doc.setFont("helvetica", "normal");
        
        const obsLines = doc.splitTextToSize(renta.observaciones || 'Sin observaciones', pageWidth - 40);
        doc.text(obsLines, 20, yPosAmp);
        
        yPosAmp += (obsLines.length * 5) + 10;
        
        // Condiciones actualizadas
        doc.setDrawColor(255, 165, 0);
        doc.roundedRect(15, yPosAmp, pageWidth - 30, 45, 3, 3);
        
        doc.setFillColor(255, 165, 0);
        doc.rect(15, yPosAmp, pageWidth - 30, 8, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(11);
        doc.setFont("helvetica", "bold");
        doc.text('CONDICIONES ACTUALIZADAS', 20, yPosAmp + 5.5);
        
        yPosAmp += 15;
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        
        doc.setFont("helvetica", "bold");
        doc.text('NUEVA FECHA FIN:', 20, yPosAmp);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(34, 139, 34);
        doc.setFontSize(12);
        doc.text(new Date(renta.fecha_fin).toLocaleDateString('es-ES'), 70, yPosAmp);
        
        yPosAmp += 10;
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.text('NUEVO TOTAL:', 20, yPosAmp);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(255, 140, 0);
        doc.setFontSize(12);
        doc.text(`Bs. ${parseFloat(renta.total).toFixed(2)}`, 70, yPosAmp);
        
        doc.setTextColor(128, 128, 128);
        doc.setFontSize(7);
        doc.text('Anexo al contrato original. Conserve ambos documentos juntos.', pageWidth / 2, pageHeight - 10, { align: 'center' });
    }
    
    // ==================== SI ESTÁ COMPLETADO, AGREGAR RECEPCIÓN ====================
// ==================== SI ESTÁ COMPLETADO, AGREGAR RECEPCIÓN ====================
    if (estaCompletado) {
        doc.addPage();
        
        // Encabezado recepción
        doc.setFillColor(220, 53, 69);
        doc.rect(0, 0, pageWidth, 45, 'F');
        
        doc.setFillColor(255, 255, 255);
        doc.circle(30, 22, 12, 'F');
        doc.setFillColor(220, 53, 69);
        doc.setFontSize(16);
        doc.setFont("helvetica", "bold");
        doc.text('AC', 30, 25, { align: 'center' });
        
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(24);
        doc.text('ALQUILACAR S.R.L.', 50, 20);
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.text('Acta de Recepción y Liquidación Final', 50, 28);
        
        doc.setFillColor(255, 193, 7);
        doc.roundedRect(pageWidth - 55, 10, 45, 12, 2, 2, 'F');
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(9);
        doc.setFont("helvetica", "bold");
        doc.text(`RECEPCIÓN`, pageWidth - 32.5, 18, { align: 'center' });
        
        doc.setTextColor(220, 53, 69);
        doc.setFontSize(18);
        doc.setFont("helvetica", "bold");
        doc.text('ACTA DE RECEPCIÓN DE VEHÍCULO', pageWidth / 2, 60, { align: 'center' });
        
        let yPosRec = 75;
        
        // Información del vehículo y cliente
        doc.setDrawColor(220, 53, 69);
        doc.setLineWidth(0.5);
        doc.roundedRect(15, yPosRec, pageWidth - 30, 35, 3, 3);
        
        doc.setFillColor(220, 53, 69);
        doc.rect(15, yPosRec, pageWidth - 30, 8, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(11);
        doc.setFont("helvetica", "bold");
        doc.text('I. INFORMACIÓN DEL VEHÍCULO Y CLIENTE', 20, yPosRec + 5.5);
        
        yPosRec += 15;
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.text('VEHÍCULO:', 20, yPosRec);
        doc.setFont("helvetica", "normal");
        doc.text(`${car.marca} ${car.modelo} - Placa: ${car.placa}`, 50, yPosRec);
        
        yPosRec += 7;
        doc.setFont("helvetica", "bold");
        doc.text('CLIENTE:', 20, yPosRec);
        doc.setFont("helvetica", "normal");
        doc.text(renta.cliente.toUpperCase(), 50, yPosRec);
        
        yPosRec += 7;
        doc.setFont("helvetica", "bold");
        doc.text('PERÍODO:', 20, yPosRec);
        doc.setFont("helvetica", "normal");
        doc.text(`${new Date(renta.fecha_inicio).toLocaleDateString('es-ES')} al ${new Date(renta.fecha_fin).toLocaleDateString('es-ES')}`, 50, yPosRec);
        
        // Comparativa de estado
        yPosRec += 15;
        doc.setDrawColor(220, 53, 69);
        doc.roundedRect(15, yPosRec, pageWidth - 30, 45, 3, 3);
        
        doc.setFillColor(220, 53, 69);
        doc.rect(15, yPosRec, pageWidth - 30, 8, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(11);
        doc.setFont("helvetica", "bold");
        doc.text('II. COMPARATIVA DE ESTADO', 20, yPosRec + 5.5);
        
        yPosRec += 15;
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        
        doc.setFont("helvetica", "bold");
        doc.text('CONCEPTO', 20, yPosRec);
        doc.text('ENTREGA', 90, yPosRec);
        doc.text('RETORNO', 145, yPosRec);
        
        yPosRec += 8;
        doc.setFont("helvetica", "normal");
        doc.text('Kilometraje:', 20, yPosRec);
        doc.text(`${renta.km_salida || 'N/A'} KM`, 90, yPosRec);
        doc.text(`${renta.km_retorno || 'N/A'} KM`, 145, yPosRec);
        
        yPosRec += 7;
        doc.text('Combustible:', 20, yPosRec);
        doc.text(renta.nivel_gasolina_salida || 'Full', 90, yPosRec);
        doc.text(renta.nivel_gasolina_retorno || 'N/A', 145, yPosRec);
        
        yPosRec += 7;
        doc.text('Estado Limpieza:', 20, yPosRec);
        doc.text('Limpio', 90, yPosRec);
        doc.text(renta.entregado_limpio ? 'Limpio' : 'Sucio', 145, yPosRec);
        
        yPosRec += 7;
        doc.setFont("helvetica", "bold");
        doc.setFillColor(240, 248, 255);
        doc.roundedRect(18, yPosRec - 3, pageWidth - 36, 8, 2, 2, 'F');
        const kmRecorridos = parseFloat(renta.km_retorno || 0) - parseFloat(renta.km_salida || 0);
        doc.text(`Kilómetros recorridos: ${kmRecorridos.toFixed(0)} KM`, 22, yPosRec + 2);
        
        // Daños reportados
        if (renta.daños_reportados && renta.daños_reportados.trim() !== '') {
            yPosRec += 18;
            doc.setDrawColor(220, 53, 69);
            doc.roundedRect(15, yPosRec, pageWidth - 30, 30, 3, 3);
            
            doc.setFillColor(220, 53, 69);
            doc.rect(15, yPosRec, pageWidth - 30, 8, 'F');
            doc.setTextColor(255, 255, 255);
            doc.setFontSize(11);
            doc.setFont("helvetica", "bold");
            doc.text('III. OBSERVACIONES Y DAÑOS', 20, yPosRec + 5.5);
            
            yPosRec += 15;
            doc.setTextColor(0, 0, 0);
            doc.setFontSize(9);
            doc.setFont("helvetica", "normal");
            const dañosLines = doc.splitTextToSize(renta.daños_reportados, pageWidth - 40);
            doc.text(dañosLines, 20, yPosRec);
            yPosRec += (dañosLines.length * 5);
        }
        
        // Liquidación económica
        yPosRec += 18;
        doc.setDrawColor(220, 53, 69);
        doc.roundedRect(15, yPosRec, pageWidth - 30, 45, 3, 3);
        
        doc.setFillColor(220, 53, 69);
        doc.rect(15, yPosRec, pageWidth - 30, 8, 'F');
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(11);
        doc.setFont("helvetica", "bold");
        doc.text('IV. LIQUIDACIÓN ECONÓMICA', 20, yPosRec + 5.5);
        
        yPosRec += 15;
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        
        doc.text('Subtotal Contrato:', 20, yPosRec);
        doc.text(`Bs. ${parseFloat(renta.total).toFixed(2)}`, pageWidth - 50, yPosRec, { align: 'right' });
        
        yPosRec += 7;
        doc.text('Garantía:', 20, yPosRec);
        doc.text(`Bs. ${parseFloat(renta.garantia).toFixed(2)}`, pageWidth - 50, yPosRec, { align: 'right' });
        
        yPosRec += 10;
        doc.setFillColor(255, 193, 7);
        doc.roundedRect(18, yPosRec - 5, pageWidth - 36, 12, 2, 2, 'F');
        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(0, 0, 0);
        const totalPagado = parseFloat(renta.monto_final_pagado || renta.total);
        doc.text(`TOTAL PAGADO: Bs. ${totalPagado.toFixed(2)}`, pageWidth / 2, yPosRec + 2, { align: 'center' });
        
        // Declaración
        yPosRec += 18;
        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");
        doc.setTextColor(0, 0, 0);
        const declaracion = 'El cliente declara haber devuelto el vehículo y realizado el pago correspondiente. Ambas partes acuerdan que el contrato ha finalizado satisfactoriamente.';
        const declLines = doc.splitTextToSize(declaracion, pageWidth - 30);
        doc.text(declLines, 15, yPosRec);
        
        doc.setFontSize(7);
        doc.setTextColor(128, 128, 128);
        doc.text('Documento generado automáticamente por el Sistema ALQUILACAR', pageWidth / 2, pageHeight - 10, { align: 'center' });
    }
    
    doc.save(`Contrato_${car.placa}_${renta.id}.pdf`);
};

    const handleAmpliarRenta = async (renta, car) => {
        const { value: fv } = await Swal.fire({
            title: 'Ampliar Renta',
            html: `
                <div class="text-start p-3">
                    <div class="alert alert-info mb-3">
                        <strong>Fecha actual de devolución:</strong><br>
                        ${new Date(renta.fecha_fin).toLocaleDateString('es-ES')}
                    </div>
                    <label class="form-label fw-bold">Nueva Fecha de Devolución:</label>
                    <input type="date" id="nf" class="form-control mb-3" min="${new Date(renta.fecha_fin).toISOString().split('T')[0]}">
                    <label class="form-label fw-bold">Precio por Día Extra:</label>
                    <input type="number" id="pe" class="form-control" value="${car.precio_dia}" step="0.50">
                </div>
            `,
            showCancelButton: true,
            confirmButtonText: 'Ampliar y Generar Contrato',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#28a745',
            width: '500px',
            preConfirm: () => ({ nf: document.getElementById('nf').value, pe: document.getElementById('pe').value })
        });
        
        if (fv && fv.nf) {
            const dias = Math.ceil((new Date(fv.nf) - new Date(renta.fecha_fin)) / (1000*60*60*24));
            if(dias <= 0) return Swal.fire('Error', 'La fecha debe ser posterior a la actual', 'error');
            
            const add = dias * parseFloat(fv.pe);
            const nt = parseFloat(renta.total) + add;
            
            try {
                await axios.put('https://api.alquilacarbolivia.com/api/operaciones/ampliar', { 
                    alquiler_id: renta.id, 
                    nueva_fecha_fin: fv.nf, 
                    monto_adicional: add, 
                    nuevo_total: nt 
                });
                
                // Generar PDF mejorado con toda la información
                generarContratoAmpliacionPDF(
                    renta, 
                    car, 
                    renta.fecha_fin,      // Fecha original
                    fv.nf,                // Nueva fecha
                    dias,                 // Días de extensión
                    add,                  // Monto adicional
                    nt                    // Nuevo total
                );
                
                handleSelectCar(car);
                
                Swal.fire({
                    title: '¡Renta Ampliada!',
                    html: `
                        <div class="text-start p-2">
                            <p class="mb-2"><strong>✓ Contrato ampliado exitosamente</strong></p>
                            <p class="mb-2">📅 Nueva fecha: <strong>${new Date(fv.nf).toLocaleDateString('es-ES')}</strong></p>
                            <p class="mb-2">📊 Días adicionales: <strong>${dias}</strong></p>
                            <p class="mb-2">💰 Monto adicional: <strong>Bs. ${add.toFixed(2)}</strong></p>
                            <p class="mb-0 text-success">📄 Contrato PDF generado automáticamente</p>
                        </div>
                    `,
                    icon: 'success',
                    confirmButtonColor: '#28a745'
                });
            } catch (error) { 
                Swal.fire('Error', 'No se pudo actualizar la ampliación', 'error'); 
            }
        }
    };

    const enviarWhatsApp = async (renta, car) => {
        try {
            await axios.post('https://api.alquilacarbolivia.com/api/operaciones/whatsapp/recordatorio', {
                telefono: renta.cliente_telefono,
                cliente: renta.cliente,
                vehiculo: `${car.marca} ${car.modelo}`,
                fecha_fin: new Date(renta.fecha_fin).toLocaleDateString()
            });
            Swal.fire('¡Enviado!', 'Recordatorio enviado por WhatsApp', 'success');
        } catch (error) { 
            Swal.fire('Error', 'No se pudo enviar (verificar bot)', 'error'); 
        }
    };

    // Filtrar vehículos
    const filteredVehiculos = filterStatus === 'todos' 
        ? vehiculos 
        : vehiculos.filter(v => v.estado === filterStatus);

    return (
        <div className="min-vh-100" style={{ 
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            position: 'relative',
            overflow: 'hidden'
        }}>
            {/* Patrón de fondo */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundImage: 'radial-gradient(circle at 1px 1px, rgba(255,255,255,0.08) 1px, transparent 0)',
                backgroundSize: '40px 40px',
                zIndex: 0
            }}></div>

            {/* HEADER PREMIUM */}
            <div className="position-relative" style={{ 
                background: 'rgba(255, 255, 255, 0.08)',
                backdropFilter: 'blur(20px)',
                borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
                zIndex: 10
            }}>
                <div className="container-fluid p-4">
                    <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                        <div className="d-flex align-items-center gap-3">
                            <button 
                                className="btn shadow-lg" 
                                onClick={goBack}
                                style={{
                                    background: 'rgba(255, 255, 255, 0.15)',
                                    backdropFilter: 'blur(10px)',
                                    border: '1px solid rgba(255, 255, 255, 0.2)',
                                    color: 'white',
                                    borderRadius: '15px',
                                    padding: '10px 20px',
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.background = 'rgba(255, 255, 255, 0.25)';
                                    e.target.style.transform = 'translateX(-5px)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.background = 'rgba(255, 255, 255, 0.15)';
                                    e.target.style.transform = 'translateX(0)';
                                }}
                            >
                                <FaArrowLeft className="me-2" />
                                Volver
                            </button>
                            
                            <div>
                                <h3 className="mb-0 fw-bold text-white d-flex align-items-center gap-2" style={{
                                    textShadow: '0 4px 12px rgba(0,0,0,0.3)',
                                    fontSize: '1.8rem'
                                }}>
                                    <FaCar style={{ fontSize: '2rem' }} />
                                    GESTIÓN DE FLOTA
                                </h3>
                                <p className="mb-0 small" style={{ color: 'rgba(255,255,255,0.7)' }}>
                                    {vehiculos.length} vehículos registrados • {vehiculos.filter(v => v.estado === 'libre').length} disponibles
                                </p>
                            </div>
                        </div>
                        
                        <button 
                            className="btn btn-lg fw-bold shadow-lg" 
                            onClick={openAddModal}
                            style={{
                                background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                                border: 'none',
                                borderRadius: '20px',
                                padding: '12px 30px',
                                color: 'white',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.target.style.transform = 'scale(1.05)';
                                e.target.style.boxShadow = '0 8px 25px rgba(17, 153, 142, 0.4)';
                            }}
                            onMouseLeave={(e) => {
                                e.target.style.transform = 'scale(1)';
                                e.target.style.boxShadow = '';
                            }}
                        >
                            <FaPlus className="me-2" />
                            Nuevo Vehículo
                        </button>
                    </div>
                </div>
            </div>

            {/* FILTROS */}
            <div className="container-fluid p-4 position-relative" style={{ zIndex: 1 }}>
                <div className="d-flex gap-2 mb-4 flex-wrap">
                    {[
                        { key: 'todos', label: 'Todos', icon: <FaCar />, count: vehiculos.length },
                        { key: 'libre', label: 'Disponibles', icon: <FaCheckCircle />, count: vehiculos.filter(v => v.estado === 'libre').length },
                        { key: 'ocupado', label: 'En Renta', icon: <FaClock />, count: vehiculos.filter(v => v.estado === 'ocupado').length }
                    ].map(filter => (
                        <button
                            key={filter.key}
                            className="btn shadow-sm"
                            onClick={() => setFilterStatus(filter.key)}
                            style={{
                                background: filterStatus === filter.key 
                                    ? 'rgba(255, 255, 255, 0.25)' 
                                    : 'rgba(255, 255, 255, 0.1)',
                                backdropFilter: 'blur(10px)',
                                border: filterStatus === filter.key 
                                    ? '2px solid rgba(255, 255, 255, 0.4)' 
                                    : '1px solid rgba(255, 255, 255, 0.2)',
                                color: 'white',
                                borderRadius: '15px',
                                padding: '10px 25px',
                                fontWeight: '600',
                                transition: 'all 0.3s ease'
                            }}
                        >
                            {filter.icon}
                            <span className="ms-2">{filter.label}</span>
                            <span className="badge bg-white text-dark ms-2">{filter.count}</span>
                        </button>
                    ))}
                </div>

                {/* GRID DE VEHÍCULOS */}
                <div className="row g-4">
                    {filteredVehiculos.map((car, index) => {
                        const alertaDoc = checkVencimiento(car.vencimiento_soat) || 
                                        checkVencimiento(car.vencimiento_ruat) || 
                                        checkVencimiento(car.vencimiento_seguro);
                        
                        return (
                            <div key={car.id} className="col-xl-3 col-lg-4 col-md-6">
                                <div 
                                    className="card h-100 border-0 shadow-lg position-relative overflow-hidden"
                                    onClick={() => handleSelectCar(car)}
                                    style={{
                                        cursor: 'pointer',
                                        borderRadius: '25px',
                                        background: 'rgba(255, 255, 255, 0.95)',
                                        backdropFilter: 'blur(20px)',
                                        transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                                        animation: `fadeInUp 0.6s ease-out ${index * 0.05}s both`
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'translateY(-10px) scale(1.02)';
                                        e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.2)';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'translateY(0) scale(1)';
                                        e.currentTarget.style.boxShadow = '';
                                    }}
                                >
                                    {/* Imagen del vehículo */}
                                    <div style={{
                                        height: '200px',
                                        position: 'relative',
                                        overflow: 'hidden',
                                        borderRadius: '25px 25px 0 0'
                                    }}>
                                        {car.imagen_url ? (
                                            <img 
                                                src={car.imagen_url} 
                                                className="w-100 h-100" 
                                                style={{
                                                    objectFit: 'cover',
                                                    transition: 'transform 0.4s ease'
                                                }}
                                                onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
                                                onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                                                alt={`${car.marca} ${car.modelo}`}
                                            />
                                        ) : (
                                            <div className="d-flex h-100 align-items-center justify-content-center" style={{
                                                background: 'linear-gradient(135deg, #e0e0e0 0%, #f5f5f5 100%)'
                                            }}>
                                                <FaCar style={{ fontSize: '4rem', color: '#ccc' }} />
                                            </div>
                                        )}
                                        
                                        {/* Badge de estado */}
                                        <div className="position-absolute top-0 end-0 m-3">
                                            <span 
                                                className="badge shadow-lg" 
                                                style={{
                                                    background: car.estado === 'libre' 
                                                        ? 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)' 
                                                        : 'linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)',
                                                    padding: '0.5rem 1rem',
                                                    borderRadius: '15px',
                                                    fontSize: '0.8rem',
                                                    fontWeight: '700',
                                                    letterSpacing: '0.5px'
                                                }}
                                            >
                                                {car.estado === 'libre' ? (
                                                    <><FaCheckCircle className="me-1" /> DISPONIBLE</>
                                                ) : (
                                                    <><FaClock className="me-1" /> EN RENTA</>
                                                )}
                                            </span>
                                        </div>

                                        {/* Alerta de documentos */}
                                        {alertaDoc && (
                                            <div className="position-absolute bottom-0 start-0 end-0 p-2" style={{
                                                background: 'linear-gradient(to top, rgba(220,53,69,0.95) 0%, transparent 100%)'
                                            }}>
                                                <small className="text-white fw-bold d-flex align-items-center justify-content-center">
                                                    <FaExclamationTriangle className="me-1" />
                                                    DOCUMENTOS POR VENCER
                                                </small>
                                            </div>
                                        )}
                                    </div>
                                    
                                    {/* Contenido de la card */}
                                    <div className="card-body p-4">
                                        <h5 className="fw-bold mb-2" style={{ color: '#2d3748' }}>
                                            {car.marca} {car.modelo}
                                        </h5>
                                        
                                        <div className="d-flex gap-2 mb-3 flex-wrap">
                                            <span className="badge bg-light text-dark" style={{
                                                padding: '0.4rem 0.8rem',
                                                borderRadius: '10px',
                                                fontSize: '0.75rem'
                                            }}>
                                                <FaIdCard className="me-1" />
                                                {car.placa}
                                            </span>
                                            <span className="badge bg-light text-dark" style={{
                                                padding: '0.4rem 0.8rem',
                                                borderRadius: '10px',
                                                fontSize: '0.75rem'
                                            }}>
                                                <FaTachometerAlt className="me-1" />
                                                {car.kilometraje_actual} KM
                                            </span>
                                        </div>

                                        <div className="d-flex justify-content-between align-items-center pt-3 border-top">
                                            <div>
                                                <small className="text-muted d-block mb-1">Tarifa diaria</small>
                                                <h4 className="mb-0 fw-bold" style={{
                                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                    WebkitBackgroundClip: 'text',
                                                    WebkitTextFillColor: 'transparent',
                                                    backgroundClip: 'text'
                                                }}>
                                                    Bs. {car.precio_dia}
                                                </h4>
                                            </div>
                                            
                                            {car.link_gps && (
                                                <div 
                                                    className="d-flex align-items-center justify-content-center rounded-circle"
                                                    style={{
                                                        width: '45px',
                                                        height: '45px',
                                                        background: 'linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)',
                                                        boxShadow: '0 4px 15px rgba(238, 9, 121, 0.3)'
                                                    }}
                                                >
                                                    <FaMapMarkerAlt style={{ color: 'white', fontSize: '1.2rem' }} />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                {filteredVehiculos.length === 0 && (
                    <div className="text-center py-5">
                        <div 
                            className="card border-0 shadow-lg mx-auto" 
                            style={{
                                maxWidth: '500px',
                                borderRadius: '25px',
                                background: 'rgba(255, 255, 255, 0.95)',
                                backdropFilter: 'blur(20px)'
                            }}
                        >
                            <div className="card-body py-5">
                                <FaCar style={{ fontSize: '5rem', color: '#ddd', marginBottom: '1rem' }} />
                                <h5 className="text-muted">No hay vehículos en esta categoría</h5>
                                <p className="text-muted small mb-0">Prueba con otro filtro</p>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            {/* MODAL DETALLE DEL VEHÍCULO */}
            {selectedCar && detalleData && (
                <div 
                    className="modal d-block" 
                    style={{ 
                        backgroundColor: 'rgba(0,0,0,0.85)',
                        backdropFilter: 'blur(5px)',
                        zIndex: 1050
                    }}
                    onClick={closeDetail}
                >
                    <div 
                        className="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-centered"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div 
                            className="modal-content border-0 shadow-lg" 
                            style={{
                                borderRadius: '30px',
                                overflow: 'hidden',
                                background: 'white'
                            }}
                        >
                            {/* Header del modal */}
                            <div style={{
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                color: 'white',
                                padding: '1.5rem 2rem'
                            }}>
                                <div className="d-flex justify-content-between align-items-center">
                                    <div>
                                        <h4 className="mb-1 fw-bold">
                                            {selectedCar.marca} {selectedCar.modelo}
                                        </h4>
                                        <p className="mb-0 opacity-75">
                                            Placa: {selectedCar.placa} • {selectedCar.anio}
                                        </p>
                                    </div>
                                    <button 
                                        className="btn btn-light rounded-circle p-2" 
                                        onClick={closeDetail}
                                        style={{ width: '45px', height: '45px' }}
                                    >
                                        ✕
                                    </button>
                                </div>
                            </div>

                            <div className="modal-body p-0">
                                <div className="row g-0">
                                    {/* Columna izquierda - Info del vehículo */}
                                    <div className="col-md-4 border-end" style={{ background: '#f8f9fa' }}>
                                        <div className="p-4">
                                            {/* Imagen */}
                                            <img 
                                                src={selectedCar.imagen_url} 
                                                className="img-fluid rounded-4 shadow-sm mb-4" 
                                                style={{ width: '100%' }}
                                                alt={`${selectedCar.marca} ${selectedCar.modelo}`}
                                            />
                                            
                                            {/* Especificaciones */}
                                            <div className="card border-0 shadow-sm mb-3" style={{ borderRadius: '15px' }}>
                                                <div className="card-header bg-white border-0 pt-3 pb-2">
                                                    <h6 className="fw-bold mb-0">
                                                        <FaInfoCircle className="me-2 text-primary" />
                                                        Especificaciones
                                                    </h6>
                                                </div>
                                                <div className="card-body">
                                                    <div className="mb-2 d-flex justify-content-between">
                                                        <span className="text-muted small">Color:</span>
                                                        <strong className="small">{selectedCar.color || 'N/A'}</strong>
                                                    </div>
                                                    <div className="mb-2 d-flex justify-content-between">
                                                        <span className="text-muted small">Año:</span>
                                                        <strong className="small">{selectedCar.anio}</strong>
                                                    </div>
                                                    <div className="mb-2 d-flex justify-content-between">
                                                        <span className="text-muted small">Kilometraje:</span>
                                                        <strong className="small">{selectedCar.kilometraje_actual} KM</strong>
                                                    </div>
                                                    <div className="d-flex justify-content-between">
                                                        <span className="text-muted small">Tarifa:</span>
                                                        <strong className="small text-success">Bs. {selectedCar.precio_dia}/día</strong>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Documentación */}
                                            <div className="card border-0 shadow-sm mb-3" style={{ borderRadius: '15px' }}>
                                                <div className="card-header bg-white border-0 pt-3 pb-2">
                                                    <h6 className="fw-bold mb-0">
                                                        <FaShieldAlt className="me-2 text-warning" />
                                                        Documentación
                                                    </h6>
                                                </div>
                                                <div className="card-body small">
                                                    {[
                                                        { label: 'SOAT', fecha: selectedCar.vencimiento_soat, icon: <FaFileContract /> },
                                                        { label: 'Seguro', fecha: selectedCar.vencimiento_seguro, icon: <FaShieldAlt /> },
                                                        { label: 'RUAT', fecha: selectedCar.vencimiento_ruat, icon: <FaFileAlt /> }
                                                    ].map((doc, i) => (
                                                        <div key={i} className="mb-2 pb-2 border-bottom d-flex justify-content-between align-items-center">
                                                            <span className="text-muted">
                                                                {doc.icon} {doc.label}:
                                                            </span>
                                                            <span className={`badge ${checkVencimiento(doc.fecha) ? 'bg-danger' : 'bg-success'}`}>
                                                                {doc.fecha ? doc.fecha.split('T')[0] : 'N/A'}
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Renta activa */}
                                            {selectedCar.estado === 'ocupado' && detalleData.rentas[0] && (
                                                <div className="card border-danger shadow-sm" style={{ borderRadius: '15px' }}>
                                                    <div className="card-header bg-danger text-white fw-bold">
                                                        <FaClock className="me-2" />
                                                        Renta Activa
                                                    </div>
                                                    <div className="card-body">
                                                        <h6 className="fw-bold mb-3">
                                                            <FaIdCard className="me-2 text-muted" />
                                                            {detalleData.rentas[0].cliente}
                                                        </h6>
                                                        <p className="small mb-3">
                                                            <strong>Devolución:</strong>
                                                            <br />
                                                            <span className="text-danger fw-bold">
                                                                {new Date(detalleData.rentas[0].fecha_fin).toLocaleDateString()}
                                                            </span>
                                                        </p>
                                                        <button 
                                                            className="btn btn-primary w-100 mb-2" 
                                                            onClick={() => handleAmpliarRenta(detalleData.rentas[0], selectedCar)}
                                                        >
                                                            <FaCalendarPlus className="me-2" />
                                                            Ampliar Días
                                                        </button>
                                                        <button 
                                                            className="btn btn-success w-100" 
                                                            onClick={() => enviarWhatsApp(detalleData.rentas[0], selectedCar)}
                                                        >
                                                            <FaWhatsapp className="me-2" />
                                                            Enviar Recordatorio
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Columna derecha - Historial */}
                                    <div className="col-md-8">
                                        <div className="p-4">
                                            {/* Tabs */}
                                            <div className="d-flex gap-2 mb-4">
                                                <button 
                                                    className={`btn flex-fill ${activeTab === 'rentas' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                    onClick={() => setActiveTab('rentas')}
                                                    style={{ borderRadius: '15px' }}
                                                >
                                                    <FaHistory className="me-2" />
                                                    Historial de Rentas
                                                </button>
                                                <button 
                                                    className={`btn flex-fill ${activeTab === 'mant' ? 'btn-primary' : 'btn-outline-primary'}`}
                                                    onClick={() => setActiveTab('mant')}
                                                    style={{ borderRadius: '15px' }}
                                                >
                                                    <FaTools className="me-2" />
                                                    Mantenimientos
                                                </button>
                                            </div>

                                            {/* Contenido de tabs */}
                                            <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                                                {activeTab === 'rentas' ? (
                                                    <div>
                                                        {detalleData.rentas.length > 0 ? (
                                                            detalleData.rentas.map(r => (
                                                                <div 
                                                                    key={r.id} 
                                                                    className="card border-0 shadow-sm mb-3"
                                                                    style={{ borderRadius: '15px' }}
                                                                >
                                                                    <div className="card-body">
                                                                        <div className="row align-items-center">

<div className="col-md-6">
    <div className="d-flex align-items-center gap-2 mb-2">
        <h6 className="fw-bold mb-0">{r.cliente}</h6>
        {(() => {
            const estadoInfo = getEstadoRenta(r);
            return (
                <span
                    className="badge"
                    style={{
                        backgroundColor: estadoInfo.bg,
                        color: estadoInfo.color,
                        fontSize: '0.7rem',
                        padding: '0.3rem 0.6rem',
                        fontWeight: '700'
                    }}
                >
                    {estadoInfo.estado}
                </span>
            );
        })()}
        {tieneAmpliaciones(r) && (
            <span
                className="badge bg-warning"
                style={{
                    fontSize: '0.65rem',
                    padding: '0.25rem 0.5rem'
                }}
                title="Contrato ampliado"
            >
                <FaCalendarPlus className="me-1" />
                AMPLIADO
            </span>
        )}
    </div>
    <p className="small text-muted mb-0">
        <FaCalendarAlt className="me-1" />
        {new Date(r.fecha_inicio).toLocaleDateString()} - {new Date(r.fecha_fin).toLocaleDateString()}
    </p>
</div>
                                                                            <div className="col-md-3 text-center">
                                                                                <small className="text-muted d-block">Total</small>
                                                                                <h5 className="mb-0 fw-bold text-success">
                                                                                    Bs. {r.total}
                                                                                </h5>
                                                                            </div>
                                                                            <div className="col-md-3 text-end">
                                                                                <button 
                                                                                    className="btn btn-sm btn-outline-primary"
onClick={() => descargarContratoPDFCompleto(r, selectedCar)}
                                                                                    style={{ borderRadius: '10px' }}
                                                                                >
                                                                                    <FaPrint className="me-1" />
                                                                                    PDF
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div className="text-center py-5">
                                                                <FaHistory style={{ fontSize: '4rem', color: '#ddd' }} />
                                                                <p className="text-muted mt-3">Sin historial de rentas</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <div>
                                                        {detalleData.mantenimientos.length > 0 ? (
                                                            detalleData.mantenimientos.map(m => (
                                                                <div 
                                                                    key={m.id} 
                                                                    className="card border-0 shadow-sm mb-3"
                                                                    style={{ borderRadius: '15px' }}
                                                                >
                                                                    <div className="card-body">
                                                                        <div className="row align-items-center">
                                                                            <div className="col-md-2">
                                                                                <div 
                                                                                    className="rounded-circle d-flex align-items-center justify-content-center"
                                                                                    style={{
                                                                                        width: '50px',
                                                                                        height: '50px',
                                                                                        background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
                                                                                    }}
                                                                                >
                                                                                    <FaTools style={{ color: 'white', fontSize: '1.2rem' }} />
                                                                                </div>
                                                                            </div>
                                                                            <div className="col-md-6">
                                                                                <h6 className="fw-bold mb-1">{m.descripcion}</h6>
                                                                                <p className="small text-muted mb-0">
                                                                                    {new Date(m.fecha_ingreso).toLocaleDateString()}
                                                                                </p>
                                                                            </div>
                                                                            <div className="col-md-4 text-end">
                                                                                <h5 className="mb-0 fw-bold text-danger">
                                                                                    Bs. {m.costo}
                                                                                </h5>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div className="text-center py-5">
                                                                <FaTools style={{ fontSize: '4rem', color: '#ddd' }} />
                                                                <p className="text-muted mt-3">Sin mantenimientos registrados</p>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Footer del modal */}
                            <div className="modal-footer bg-light border-0 p-4">
                                <div className="d-flex justify-content-between w-100">
                                    <div className="d-flex gap-2">
                                        <button 
                                            className="btn btn-danger" 
                                            onClick={() => handleDelete(selectedCar)}
                                            style={{ borderRadius: '15px' }}
                                        >
                                            <FaTrash className="me-2" />
                                            Eliminar
                                        </button>
                                        <button 
                                            className="btn btn-warning" 
                                            onClick={() => openEditModal(selectedCar)}
                                            style={{ borderRadius: '15px' }}
                                        >
                                            <FaEdit className="me-2" />
                                            Editar
                                        </button>
                                    </div>
                                    <button 
                                        className="btn btn-secondary px-4" 
                                        onClick={closeDetail}
                                        style={{ borderRadius: '15px' }}
                                    >
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* MODAL AÑADIR/EDITAR VEHÍCULO - ACTUALIZADO CON PREVIEW DE IMAGEN */}
            {showModal && (
                <div 
                    className="modal d-block" 
                    style={{ 
                        backgroundColor: 'rgba(0,0,0,0.85)',
                        backdropFilter: 'blur(5px)',
                        zIndex: 1060
                    }}
                    onClick={() => setShowModal(false)}
                >
                    <div 
                        className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div 
                            className="modal-content border-0 shadow-lg" 
                            style={{ borderRadius: '30px', overflow: 'hidden' }}
                        >
                            <div style={{
                                background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                                color: 'white',
                                padding: '1.5rem 2rem'
                            }}>
                                <h5 className="mb-0 fw-bold">
                                    {modalMode === 'add' ? (
                                        <><FaPlus className="me-2" />Registrar Nuevo Vehículo</>
                                    ) : (
                                        <><FaEdit className="me-2" />Editar Información del Vehículo</>
                                    )}
                                </h5>
                            </div>

                            <form onSubmit={handleSaveVehiculo}>
                                <div className="modal-body p-4" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                                    {/* SECCIÓN DE IMAGEN - NUEVO */}
                                    <div className="text-center mb-4">
                                        <label 
                                            className="btn btn-outline-secondary w-100 p-0 position-relative overflow-hidden" 
                                            style={{ 
                                                borderRadius: '20px', 
                                                height: '200px',
                                                borderStyle: 'dashed',
                                                borderWidth: '2px',
                                                cursor: 'pointer',
                                                transition: 'all 0.3s ease'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.borderColor = '#11998e';
                                                e.currentTarget.style.background = 'rgba(17, 153, 142, 0.05)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.borderColor = '';
                                                e.currentTarget.style.background = '';
                                            }}
                                        >
                                            {imagePreview ? (
                                                <img 
                                                    src={imagePreview} 
                                                    className="h-100 w-100" 
                                                    style={{ objectFit: 'cover' }}
                                                    alt="Preview"
                                                />
                                            ) : (
                                                <div className="d-flex flex-column align-items-center justify-content-center h-100">
                                                    <FaFileUpload style={{ fontSize: '3rem', color: '#ccc', marginBottom: '1rem' }} />
                                                    <p className="mb-0 text-muted fw-semibold">
                                                        {modalMode === 'add' ? 'Subir Foto del Vehículo' : 'Cambiar Imagen del Vehículo'}
                                                    </p>
                                                    <small className="text-muted mt-2">Click para seleccionar (JPG, PNG - Máx. 5MB)</small>
                                                </div>
                                            )}
                                            <input 
                                                type="file" 
                                                hidden 
                                                accept="image/*" 
                                                onChange={handleImageChange}
                                            />
                                        </label>
                                        {imagePreview && (
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-danger mt-2"
                                                onClick={() => {
                                                    setImagePreview(null);
                                                    setForm({ ...form, imagen: null });
                                                }}
                                                style={{ borderRadius: '10px' }}
                                            >
                                                <FaTrash className="me-1" />
                                                Quitar Imagen
                                            </button>
                                        )}
                                    </div>

                                    {/* Información básica */}
                                    <h6 className="fw-bold text-secondary mb-3 pb-2 border-bottom">
                                        <FaCar className="me-2" />
                                        Información Básica
                                    </h6>
                                    <div className="row g-3 mb-4">
                                        <div className="col-md-4">
                                            <label className="form-label fw-semibold small">Marca *</label>
                                            <input 
                                                className="form-control" 
                                                value={form.marca || ''} 
                                                required 
                                                onChange={e => setForm({...form, marca: e.target.value})}
                                                style={{ borderRadius: '10px' }}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label fw-semibold small">Modelo *</label>
                                            <input 
                                                className="form-control" 
                                                value={form.modelo || ''} 
                                                required 
                                                onChange={e => setForm({...form, modelo: e.target.value})}
                                                style={{ borderRadius: '10px' }}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label fw-semibold small">Placa *</label>
                                            <input 
                                                className="form-control" 
                                                value={form.placa || ''} 
                                                required 
                                                onChange={e => setForm({...form, placa: e.target.value})}
                                                style={{ borderRadius: '10px' }}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label fw-semibold small">Año</label>
                                            <input 
                                                type="number"
                                                className="form-control" 
                                                value={form.anio || ''} 
                                                onChange={e => setForm({...form, anio: e.target.value})}
                                                style={{ borderRadius: '10px' }}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label fw-semibold small">Color</label>
                                            <input 
                                                className="form-control" 
                                                value={form.color || ''} 
                                                onChange={e => setForm({...form, color: e.target.value})}
                                                style={{ borderRadius: '10px' }}
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label fw-semibold small">Precio/Día (Bs) *</label>
                                            <input 
                                                type="number" 
                                                step="0.01"
                                                className="form-control border-success" 
                                                value={form.precio_dia || ''} 
                                                required 
                                                onChange={e => setForm({...form, precio_dia: e.target.value})}
                                                style={{ borderRadius: '10px', borderWidth: '2px' }}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold small">Kilometraje Actual</label>
                                            <input 
                                                type="number" 
                                                className="form-control" 
                                                value={form.kilometraje_actual || ''} 
                                                onChange={e => setForm({...form, kilometraje_actual: e.target.value})}
                                                style={{ borderRadius: '10px' }}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold small">Link GPS (Google Maps)</label>
                                            <input 
                                                className="form-control border-primary" 
                                                value={form.link_gps || ''} 
                                                onChange={e => setForm({...form, link_gps: e.target.value})}
                                                style={{ borderRadius: '10px' }}
                                                placeholder="https://maps.google.com/..."
                                            />
                                        </div>
                                    </div>

                                    {/* Documentación */}
                                    <h6 className="fw-bold text-secondary mb-3 pb-2 border-bottom">
                                        <FaShieldAlt className="me-2" />
                                        Documentación y Vencimientos
                                    </h6>
                                    <div className="row g-3 mb-4">
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold small text-danger">
                                                <FaFileContract className="me-1" />
                                                Vencimiento SOAT
                                            </label>
                                            <input 
                                                type="date" 
                                                className="form-control border-danger" 
                                                value={form.vencimiento_soat || ''} 
                                                onChange={e => setForm({...form, vencimiento_soat: e.target.value})}
                                                style={{ borderRadius: '10px', borderWidth: '2px' }}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold small text-danger">
                                                <FaShieldAlt className="me-1" />
                                                Vencimiento Seguro
                                            </label>
                                            <input 
                                                type="date" 
                                                className="form-control border-danger" 
                                                value={form.vencimiento_seguro || ''} 
                                                onChange={e => setForm({...form, vencimiento_seguro: e.target.value})}
                                                style={{ borderRadius: '10px', borderWidth: '2px' }}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold small">
                                                <FaFileAlt className="me-1" />
                                                Vencimiento RUAT
                                            </label>
                                            <input 
                                                type="date" 
                                                className="form-control" 
                                                value={form.vencimiento_ruat || ''} 
                                                onChange={e => setForm({...form, vencimiento_ruat: e.target.value})}
                                                style={{ borderRadius: '10px' }}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold small">
                                                <FaMoneyBillWave className="me-1" />
                                                Pago de Impuestos
                                            </label>
                                            <input 
                                                type="date" 
                                                className="form-control" 
                                                value={form.vencimiento_impuestos || ''} 
                                                onChange={e => setForm({...form, vencimiento_impuestos: e.target.value})}
                                                style={{ borderRadius: '10px' }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-footer bg-light border-0 p-4">
                                    <button 
                                        type="button"
                                        className="btn btn-secondary px-4" 
                                        onClick={() => setShowModal(false)}
                                        style={{ borderRadius: '15px' }}
                                    >
                                        Cancelar
                                    </button>
                                    <button 
                                        type="submit" 
                                        className="btn btn-primary px-4 fw-bold"
                                        style={{
                                            borderRadius: '15px',
                                            background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
                                            border: 'none'
                                        }}
                                    >
                                        <FaCheckCircle className="me-2" />
                                        {modalMode === 'add' ? 'Registrar Vehículo' : 'Guardar Cambios'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* ESTILOS */}
            <style>{`
                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                .modal {
                    animation: fadeIn 0.3s ease-out;
                }

                @keyframes fadeIn {
                    from { opacity: 0; }
                    to { opacity: 1; }
                }

                /* Scroll personalizado */
                ::-webkit-scrollbar {
                    width: 8px;
                    height: 8px;
                }

                ::-webkit-scrollbar-track {
                    background: #f1f1f1;
                    border-radius: 10px;
                }

                ::-webkit-scrollbar-thumb {
                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                    border-radius: 10px;
                }

                ::-webkit-scrollbar-thumb:hover {
                    background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
                }
            `}</style>
        </div>
    );
}
